module.exports = __webpack_public_path__ + "media/images/curriculum_2-41808f3c4f54220846ad809ef5f9b875.png";